import type { BridgeToApiPromptResultMessage } from '../../../types/bridge-to-api-messages.js';
import type { AcpClientHandle } from '../clients/acp-client.js';
import type { AcpManagerContext } from './acp-manager-context.js';

export async function handlePendingPromptCancel(params: {
  ctx: AcpManagerContext;
  activeRunId: string;
  promptId?: string;
  sessionId?: string;
  handle: AcpClientHandle;
  sendResult: (result: BridgeToApiPromptResultMessage) => void;
}): Promise<boolean> {
  const { ctx, activeRunId, promptId, sessionId, handle, sendResult } = params;

  if (!ctx.pendingCancelRunIds.has(activeRunId)) {
    return false;
  }

  ctx.pendingCancelRunIds.delete(activeRunId);
  try {
    await handle.cancel?.();
  } catch {
    /* ignore */
  }
  sendResult({
    type: 'prompt_result',
    id: promptId,
    ...(sessionId ? { sessionId } : {}),
    runId: activeRunId,
    success: false,
    error: 'Stopped by user',
    stopReason: 'cancelled',
  });
  return true;
}
